import Vue from 'vue'
import OverlayApi from '../apis/overlay'
export const state = () => ({
  token: "",
  url: "",
  name: "",
  id: "",
  specific_position_flag: false
});
export const actions = {
  async copy({ commit, state }) {
    return await OverlayApi.copy(state)
  },
}
export const mutations = {
  setToken(state, token){
    state.token = token
  },
  setUrl(state, url){
    state.url = url
  },
  setName(state, name){
    state.name = name
  },
  setId(state, id){
    state.id = id
  },
  setSpecificPositionFlag(state, bool){
    state.specific_position_flag = bool
  },
}
export const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
